import { accountsActions } from './accounts-slice'
import store from './index'
import { handleError, handleSessionExpired } from './error-handler';

export const fetchAccountsList = () => {
    return async (dispatch) => {
        const fetchData = async () => {
            dispatch(accountsActions.setIsLoading(true))
            const url = store.getState().auth.url
            var bearer = 'Bearer ' + localStorage.getItem('token');
            const response = await fetch( url + 'api/accounts', {
                headers:{
                    'Authorization': bearer,
                }
            });

            if (!response.ok) {
                if(response.status === 401){ 
                    handleSessionExpired(dispatch, bearer)
                    throw new Error('Your session has expired. Please log in again.')
                }
                else{ throw new Error('Could not fetch accounts list.') }
            }
            const data = await response.json()
            return data;
        };

        try {
            const accountsData = await fetchData()
            dispatch(accountsActions.loadAccounts({ accounts: accountsData || [] }))
        } catch (error) {
            handleError(dispatch, error)
        }
        finally {
            dispatch(accountsActions.setIsLoading(false))
        }
    };
};

export const setAccountIsLoading = (value) => {
    return (dispatch) => {
        dispatch(accountsActions.setIsLoading(value))
    }
}

